/**
 * Custom Popup Component
 * Handles opening and closing of the popup modal
 */

class CustomPopup {
  constructor() {
    this.trigger = document.querySelector('[data-popup-trigger]');
    this.overlay = document.querySelector('[data-popup-overlay]');
    this.closeBtn = document.querySelector('[data-popup-close]');

    if (!this.trigger || !this.overlay) return;

    this.init();
  }

  init() {
    // Open popup when trigger button is clicked
    this.trigger.addEventListener('click', () => this.open());

    // Close popup when close button is clicked
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }

    // Close popup when clicking outside the modal
    this.overlay.addEventListener('click', (e) => {
      if (e.target === this.overlay) {
        this.close();
      }
    });

    // Close popup when pressing Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.overlay.classList.contains('is-active')) {
        this.close();
      }
    });
  }

  open() {
    this.overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden'; // Prevent background scrolling
    document.body.classList.add('popup-active'); // Add class to disable sticky elements
  }

  close() {
    this.overlay.classList.remove('is-active');
    document.body.style.overflow = ''; // Restore scrolling
    document.body.classList.remove('popup-active'); // Remove class to re-enable sticky elements
  }
}

// Initialize popup when DOM is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new CustomPopup());
} else {
  new CustomPopup();
}
